import { render, staticRenderFns } from "./PaowFacebookLoginButton.vue?vue&type=template&id=0423146a&scoped=true&"
import script from "./PaowFacebookLoginButton.vue?vue&type=script&lang=js&"
export * from "./PaowFacebookLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0423146a",
  null
  
)

/* custom blocks */
import block0 from "./PaowFacebookLoginButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VIcon,VLayout,VSpacer})
